/*
Auth0 Configuration for React SDK: https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html

Auth0 React NPM Package: https://github.com/auth0/auth0-react

##### Local Development Notes #####
- Consent screen is always shown for localhost: https://auth0.com/docs/get-started/applications/confidential-and-public-applications/user-consent-and-third-party-applications#skip-consent-for-first-party-applications

- We can only set one Application Login URI so when developing locally, when Auth0 redirects it will go to our login page for the Dev environment
- ^More info on the above: https://auth0.com/docs/authenticate/login/auth0-universal-login/configure-default-login-routes

- http://localhost:5173 is added to the our application's Allowed Callback URLs, Allowed Logout URLs, and Allowed Web Origins so that when Auth0 redirects back to our app after login, it will go to localhost:5173
- ^More info on the above: https://auth0.com/docs/get-started/applications/work-with-auth0-locally and https://github.com/auth0/auth0-react?tab=readme-ov-file#configure-auth0
*/

import { runtimeConfig } from '../config/runtimeConfig';

export const auth0Config = {
  domain: runtimeConfig.auth0Domain || '',
  clientId: runtimeConfig.auth0ClientId || '',
  authorizationParams: {
    redirect_uri: `${window.location.origin}/`,
    audience: runtimeConfig.auth0Audience || '',
    scope: 'openid profile email offline_access',
    connection: 'Merchant-Portal-Username-Password-Authentication',
  },
  cacheLocation: 'memory' as const, // Stores tokens in memory only. More info on Token Storage: https://auth0.com/docs/secure/security-guidance/data-security/token-storage
  useRefreshTokens: true, // More info on refresh tokens: https://auth0.com/docs/secure/tokens/refresh-tokens
  useRefreshTokensFallback: true, // Enables iframe fallback when refresh tokens fail (Auth0 SDK v2 behavior)
};
